module.exports = __webpack_public_path__ + "img/side_seam_pocket_position.d003f22c.png";